import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../../../services/api';
import EmployeeProfitabilityPanel from '../../../components/production/profitability/EmployeeProfitabilityPanel';
import { ArrowLeft, User } from 'lucide-react';

/**
 * Page de détail employé minimale
 * Objectif : Afficher le panel de rentabilité employé
 */
const EmployeeDetail = () => {
  const { employeeId } = useParams();
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    async function fetchEmployee() {
      try {
        setLoading(true);
        setError('');
        const response = await api.get(`/api/employees/${employeeId}`);
        // L'API retourne {employee: {...}}
        setEmployee(response.data.employee || response.data);
      } catch (err) {
        console.error('Erreur chargement employé:', err);
        setError('Impossible de charger les données de l\'employé.');
      } finally {
        setLoading(false);
      }
    }
    
    if (employeeId) {
      fetchEmployee();
    }
  }, [employeeId]);

  if (loading) {
    return (
      <div className="container mx-auto px-6 py-8">
        <div className="text-center text-gray-500">
          <div className="animate-pulse">⏳ Chargement...</div>
        </div>
      </div>
    );
  }

  if (error || !employee) {
    return (
      <div className="container mx-auto px-6 py-8">
        <div className="bg-red-50 border border-red-200 rounded-xl p-6">
          <div className="text-red-700">⚠️ {error || 'Employé introuvable'}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-6 py-8" style={{ maxWidth: '1400px' }}>
      {/* Header */}
      <div className="mb-6">
        <Link 
          to="/admin/erp/employees" 
          className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-4"
        >
          <ArrowLeft size={20} />
          Retour à la liste
        </Link>
        
        <div className="flex items-center gap-4">
          <div className="bg-gray-100 rounded-full p-4">
            <User size={32} className="text-gray-600" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-gray-900">
              {employee.first_name} {employee.last_name}
            </h1>
            <p className="text-gray-500">{employee.email}</p>
          </div>
        </div>
      </div>

      {/* Panel de rentabilité */}
      <EmployeeProfitabilityPanel employeeId={employeeId} />
    </div>
  );
};

export default EmployeeDetail;
